export default function ToggleSwitch({
  name,
  checked,
  onChange,
  label,
  icon,
  className = "",
}) {
  return (
    <label
      className={`flex items-center justify-between gap-3 cursor-pointer select-none ${className}`}
    >
      <span className="flex items-center gap-2 text-sm text-gray-800">
        {icon && (
          <span className="text-base" aria-hidden="true">
            {icon}
          </span>
        )}
        <span>{label}</span>
      </span>
      <span className="relative inline-flex items-center w-11 h-6 flex-shrink-0">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          className="sr-only peer"
        />
        <span className="absolute inset-0 rounded-full bg-gray-300 peer-checked:bg-[#586989] transition-colors duration-200 pointer-events-none" />
        <span className="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform duration-200 peer-checked:translate-x-5 pointer-events-none" />
      </span>
    </label>
  );
}
